function convertToLowercase(value) {
  if (value) {
    return value.toLowerCase()
  }
  return value
}

export default convertToLowercase
